import React from 'react';

export default function Badge(props) {
    const elProps = {};
    if (props.noMargin) {
        elProps['data-no-margin'] = true;
    }
    return (
        <span className="c_15" {...elProps}>{props.desc}</span>
    );
}
